import { z } from 'zod';
import { BaseEventSchema } from './Base';

const ScrollEventSchema = BaseEventSchema.extend({
  scroll_percentage: z.number(),
});

const LandingEventSchema = BaseEventSchema.extend({
  referral_link: z.union([z.string(), z.array(z.string())]).optional(),
  logged: z.boolean(),
});

const ProductViewEventSchema = BaseEventSchema.extend({
  product_id: z.number(),
  product_name: z.string(),
  product_price: z.number().optional(),
  product_prescription_type: z.string().optional(),
  product_brand: z.string(),
  product_availability: z.string(),
});

const NewAddressViewSchema = BaseEventSchema.extend({
  screen_version: z.union([
    z.literal('form'),
    z.literal('map'),
    z.literal('confirmation'),
  ]),
});

export enum ScreenEventType {
  // Screens
  ScreenHomeView = 'screen.home.view',
  ScreenHomeScroll = 'screen.home.scroll',
  ScreenLandingView = 'screen.landing.view',
  ScreenLandingScroll = 'screen.landing.scroll',
  ScreenResultsView = 'screen.results.view',
  ScreenProductView = 'screen.product.view',
  ScreenLastWhimView = 'screen.last_whim.view',
  ScreenMyOrdersView = 'screen.my_orders.view',
  ScreenMyPrescriptionsView = 'screen.my_prescriptions.view',
  ScreenMyAddressesView = 'screen.my_addresses.view',
  ScreenMyPaymentMethodsView = 'screen.my_payment_methods.view',
  ScreenMyUserInfoView = 'screen.my_user_info.view',
  ScreenMyInsurancesView = 'screen.my_insurances.view',
  ScreenNewAddressView = 'screen.new_address.view',
  // Checkout
  ScreenCheckoutDeliveryAddressView = 'screen.checkout.delivery_address.view',
  ScreenCheckoutDeliveryDateView = 'screen.checkout.delivery_date.view',
  ScreenCheckoutPaymentMethodView = 'screen.checkout.payment_method.view',
  ScreenCheckoutInstallmentsView = 'screen.checkout.installments.view',
  ScreenCheckoutPrescriptionsView = 'screen.checkout.prescriptions.view',
  ScreenCheckoutConfirmPaymentView = 'screen.checkout.confirm_payment.view',
  ScreenCheckoutPaymentSuccessView = 'screen.checkout.payment_success.view',
  // Errors
  ScreenSearchErrorView = 'screen.search_error.view',
  ScreenGenericErrorView = 'screen.generic_error.view',
}

export const ScreenEventTrackingSchemas = {
  [ScreenEventType.ScreenHomeView]: BaseEventSchema,
  [ScreenEventType.ScreenHomeScroll]: ScrollEventSchema,
  [ScreenEventType.ScreenLandingView]: LandingEventSchema,
  [ScreenEventType.ScreenLandingScroll]: ScrollEventSchema,
  [ScreenEventType.ScreenResultsView]: BaseEventSchema,
  [ScreenEventType.ScreenProductView]: ProductViewEventSchema,
  [ScreenEventType.ScreenLastWhimView]: BaseEventSchema,
  [ScreenEventType.ScreenMyOrdersView]: BaseEventSchema,
  [ScreenEventType.ScreenMyPrescriptionsView]: BaseEventSchema,
  [ScreenEventType.ScreenMyAddressesView]: BaseEventSchema,
  [ScreenEventType.ScreenMyPaymentMethodsView]: BaseEventSchema,
  [ScreenEventType.ScreenMyUserInfoView]: BaseEventSchema,
  [ScreenEventType.ScreenMyInsurancesView]: BaseEventSchema,
  [ScreenEventType.ScreenNewAddressView]: NewAddressViewSchema,
  [ScreenEventType.ScreenCheckoutDeliveryAddressView]: BaseEventSchema,
  [ScreenEventType.ScreenCheckoutDeliveryDateView]: BaseEventSchema,
  [ScreenEventType.ScreenCheckoutPaymentMethodView]: BaseEventSchema,
  [ScreenEventType.ScreenCheckoutInstallmentsView]: BaseEventSchema,
  [ScreenEventType.ScreenCheckoutPrescriptionsView]: BaseEventSchema,
  [ScreenEventType.ScreenCheckoutConfirmPaymentView]: BaseEventSchema,
  [ScreenEventType.ScreenCheckoutPaymentSuccessView]: BaseEventSchema,
  [ScreenEventType.ScreenSearchErrorView]: BaseEventSchema,
  [ScreenEventType.ScreenGenericErrorView]: BaseEventSchema,
} as const;
